// Backend hazır olana kadar mock veri döner, hazır olduğunda Api.get/post çağrılarına bağlanacak.
const mockApplications = [
    {
        id: 1,
        posting_id: 1,
        company_name: "KALT Elektronik",
        position: "Pazarlama Management Trainee (Co-op)",
        responsible_name: "Barış Topyıldız",
        location: "İstanbul",
        quota: 5,
        application_date: "06.12.2025",
        fee: "Ücretli",
        status: "in_review",
        documents: [
            { code: "ek1", label: "Ek 1", status: "accepted", file_name: null },
            { code: "ek2", label: "Ek 2", status: "accepted", file_name: null },
            { code: "ek3", label: "Ek 3", status: "accepted", file_name: null }
        ]
    }
];

const getAll = async (config) => {
    const filter = config?.params?.filter ?? {};
    let rows = [...mockApplications];

    if (filter.company_name) {
        rows = rows.filter((row) => row.company_name.toLowerCase().includes(filter.company_name.toLowerCase()));
    }

    return Promise.resolve({
        data: {
            data: rows,
            pagination: {
                total: rows.length
            }
        }
    });
};

const saveDocuments = async (id, documents) => {
    const row = mockApplications.find((item) => item.id === Number(id));
    if (row) {
        row.documents = documents.map((doc) => ({
            ...doc,
            file_name: doc.file ? doc.file.name : doc.file_name
        }));
    }
    return Promise.resolve({
        data: {
            data: row ?? null
        }
    });
};

export default {
    getAll,
    saveDocuments
}
